import CallLog from "../../../classes/CallLog";
import { db } from "../../../boot/firebase";
import { collection, deleteDoc, doc, setDoc } from "firebase/firestore";

export const GET_CALL_LOG = ({ dispatch }, id) => {
  return dispatch("GET_DOC", {
    converter: CallLog,
    path: CallLog.getPath(id),
    stateKey: "callLogs",
    stateID: id,
    id,
  });
};

export const GET_CALL_LOGS = ({ dispatch }, { where, limit, pagination }) => {
  return dispatch("GET_COLLECTION", {
    converter: CallLog,
    path: CallLog.getPath(),
    stateKey: "callLogs",
    where,
    limit,
    pagination,
  });
};

export const LISTEN_CALL_LOG = (
  { dispatch },
  { id, next, error, unlisten }
) => {
  return dispatch("LISTEN_DOC", {
    converter: CallLog,
    path: CallLog.getPath(id),
    stateKey: "callLogs",
    id,
    next,
    error,
    unlisten,
  });
};

export const LISTEN_CALL_LOGS = (
  { dispatch },
  { where, pagination, next, error, unlisten }
) => {
  return dispatch("LISTEN_COLLECTION", {
    converter: CallLog,
    path: CallLog.getPath(),
    stateKey: "callLogs",
    where,
    pagination,
    next,
    error,
    unlisten,
  });
};

export const SAVE_CALL_LOG = async ({ commit, state }, { id, data }) => {
  const now = new Date();
  const user = state.user;

  // Create a CallLog instance
  const log = new CallLog(id, data);

  if (!id) {
    // Creating new - generate ID
    log.data.created = now;
    log.data.createdBy = user.id;

    const ref = doc(collection(db, CallLog.getPath()));
    log.id = ref.id;

    await setDoc(ref, log.toFirestore());
  } else {
    // Updating existing
    log.data.modified = now;
    log.data.modifiedBy = user.id;

    await setDoc(doc(db, CallLog.getPath(id)), log.toFirestore());
  }

  // Update local state
  commit("SET", { stateKey: "callLogs", stateID: log.id, doc: log });

  return log;
};

export const DELETE_CALL_LOG = async ({ commit }, id) => {
  await deleteDoc(doc(db, CallLog.getPath(id)));
  commit("REMOVE", { stateKey: "callLogs", id });
};
